import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSadTear } from '@fortawesome/free-solid-svg-icons'
import styles from './no-data.module.scss'

export default function NoData() {
  return (
    <div className={styles.noData}>
      <FontAwesomeIcon icon={faSadTear} />
      <span>No Result Found</span>
    </div>
  )
}
